import { render, staticRenderFns } from "./VariantCreateUpdateDialog.vue?vue&type=template&id=49158a8e&scoped=true&"
import script from "./VariantCreateUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./VariantCreateUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49158a8e",
  null
  
)

export default component.exports